import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Upload } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { VisuallyHiddenInputStyle } from "./style";
import { VisuallyHiddenInputProps } from "./type";

export const VisuallyHiddenInput: React.FC<VisuallyHiddenInputProps> =
  ({ name, label, type, accept, onChange, error, errorMessage, readOnly }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
      <Box
        component="label"
        htmlFor={ name }
        sx={ {
          color: theme.customColors.textPrimary,
          ...(readOnly
            ? {}
            : {
              "&:hover": {
                border: `1px solid ${theme.customColors.borderAccent}`
              }
            }),
          alignItems: "center",
          border: `1px solid ${theme.customColors.border}`,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          paddingLeft: theme.spacing(1.2),
          paddingRight: theme.spacing(0.8),
          height: "2.27rem",
          // minWidth: "fit-content",
          // width: "10rem",
          position: "relative",
          borderRadius: "0.5rem",
          gap: "1.5rem"
        } }
      >
        <Typography
          color={ theme.customColors.exploreCardText }
          fontSize={ "0.875rem" }
        >
          { label }
        </Typography>

        <Upload 
          aria-label={ t("upload_file") } 
          size={ "1rem" } 
          color={ theme.customColors.exploreCardText }
        />
        <VisuallyHiddenInputStyle
          id={ name }
          type={ type }
          accept={ accept }
          onChange={ onChange }
          disabled={ readOnly }
        />
        { error && (
          <div
            style={ {
              color: theme.customColors.textError,
              left: 0,
              position: "absolute",
              right: "0%",
              top: "100%"
            } }
          >
            { errorMessage }
          </div>
        ) }
      </Box>
    );
  };
